import { Point, Sprite } from 'pixi.js-legacy';
import Textures from '../textures';
export class DeckingOptions {
    constructor() {
        this.position = new Point(0, 0);
        this.xDim = 0;
        this.yDim = 0;
    }
}
export class Decking extends Sprite {
    constructor(options = new DeckingOptions()) {
        super(Textures.getInstance().Decking);
        this.name = 'Decking';
        this.position.copyFrom(options.position);
        this.width = options.xDim;
        this.height = options.yDim;
    }
    destroy(options) {
        super.destroy({
            children: options.children,
            baseTexture: options.baseTexture,
        });
    }
}
